import * as React from "react";

const IconHeaderPhone: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="currentColor"><path fill="currentColor" d="M0.75,0.75 L0.75,11.25 L6.75,11.25 L6.75,0.75 L0.75,0.75 Z M0,0 L0.75,0 L6.75,0 L7.5,0 L7.5,0.75 L7.5,11.25 L7.5,12 L6.75,12 L0.75,12 L0,12 L0,11.25 L0,0.75 L0,0 Z M3,9.375 L4.5,9.375 L4.875,9.375 L4.875,10.125 L4.5,10.125 L3,10.125 L2.625,10.125 L2.625,9.375 L3,9.375 Z" transform="translate(.75 .5)"/></svg>;
};

export default React.memo(IconHeaderPhone);
